define(['angular', 'moment'], function(angular, moment) {


    /**
     * @class AuthService
     */
    function AuthService($rootScope, $window, $q, $log, $cookies, authProvider) {
        let self = this;

        self.updateLoginStatus = function() {
            self.token = $cookies.get('accessToken');
            if (!self.token) {
                $rootScope.isLogin = false;
            }
        };

        self.login = function() {
            return authProvider.getAuthUrl().then(function(res) {
                document.location.href = res.data;
            });
        };

        self.loginHelpline = function (){
            return authProvider.loginHelpline().then(function (res){
                document.location.href = res.data;
            })
        }

        return self;
    }

    AuthService.$inject = ['$rootScope', '$window', '$q', '$log', '$cookies', 'auth'];

    angular.module('app.portal.authService', []).factory('authService', AuthService);
});
